






















import icons from '@/mixins/icons';
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Job from '@/interfaces/models/Job';
import { exportServiceCenter } from '@/services/graph/export.graph';
import config from '@/config';
import axios, { AxiosResponse } from 'axios';

@Component
export default class ExportButton extends mixins(icons) {
  @Prop({ required: true }) country!: string;
  @Prop({ required: true }) product!: string;
  @Prop({ required: true }) customer!: string;

  isLoading: boolean = false;
  jobStatus: string = 'in_progress';
  inPoolingMode: boolean = false;
  isLoadingExport: boolean = false;

  async serviceCenterExport() {
    let job: Job;
    this.isLoading = true;
    this.isLoadingExport = true;
    try {
      job = (
        await exportServiceCenter({ productId: this.product, country: this.country, customer: this.customer })
      ).data.exportServiceCenter;
    } catch (e) {
      console.log(e);
      return;
    } finally {
      this.isLoading = false;
    }
    this.inPoolingMode = true;
    this.jobStatus = job.status;
    let jobResponse: AxiosResponse<{ data: Job }>;
    const intervalId = setInterval(async () => {
      jobResponse = await axios.get(`${config.API_BASE_URL}/v2/job-center/${job._id}/`);
      this.jobStatus = jobResponse.data.data.status;
      if (jobResponse.data.data.status === 'success') {
        try {
          // @ts-ignore
          window.open(new URL(jobResponse.data.data.result));
        } catch (error) {
          clearInterval(intervalId);
          alert('Could not export!');
        }
        this.inPoolingMode = false;
        this.isLoadingExport = false;
        clearInterval(intervalId);

        this.jobStatus = jobResponse.data.data.status;

        alert('Successfully exported!');
      } else if (jobResponse.data.data.status === 'error') {
        this.inPoolingMode = false;
        this.isLoadingExport = false;
        alert('Could not export!');
        clearInterval(intervalId);
      }
    }, 5000);
  }
}
